/**
 * Checks if `value` is a global object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
 */
function checkGlobal(value) {
  return (value && value.Object === Object) ? value : null;
}

export default checkGlobal;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_checkGlobal.js
// module id = 8
// module chunks = 0